import { GlobalConfigType, setApplicationStep } from 'actions'
import cloneDeep from 'clone-deep'
import { IVisibleProp, LoanFieldProps } from 'config'
import { getEffectiveFieldRequiredForBorrower } from 'config/borrowerFieldRequired.util'
import { store } from 'reducers'
import { InputValidate } from 'utils'
import { getInvisibleFields, isVisibleFieldVisibleProps } from 'utils/loan'

import { BorrowerSeperator } from '../config'
import { borrowerMenuKey } from '../util'
import { defaultInputs } from './constants'

export const customInformationValidate = (
  borrowerSeperator: BorrowerSeperator,
  fieldOrigin: string,
  validateOnly = false,
  updateStore = false,
) => {
  const fields = defaultInputs(fieldOrigin)
  const { borrower, step, globalConfigReducer } = store.getState()
  const loanFieldProperties = globalConfigReducer[GlobalConfigType.LoanFields] as LoanFieldProps

  if (((loanFieldProperties as any)['visibility'] || {})[fieldOrigin] === false) {
    if (validateOnly) return true
    else return {}
  }

  const pageProps = (loanFieldProperties as any).properties?.[fieldOrigin] || {}
  if (pageProps.visibleByBorrower?.[borrowerSeperator] === false) {
    if (updateStore) {
      let application = cloneDeep(step.application)
      const key = borrowerMenuKey(borrowerSeperator, fieldOrigin)
      application[key] = 1
      store.dispatch(setApplicationStep(application))
    }
    if (validateOnly) return true
    return {}
  }

  if (pageProps.visibleLogic?.length && !isVisibleFieldVisibleProps({ visibleLogic: pageProps.visibleLogic })) {
    if (updateStore) {
      let application = cloneDeep(step.application)
      const key = borrowerMenuKey(borrowerSeperator, fieldOrigin)
      application[key] = 1
      store.dispatch(setApplicationStep(application))
    }
    if (validateOnly) return true
    return {}
  }

  const fieldProps = (loanFieldProperties[fieldOrigin] || {}) as Record<string, IVisibleProp>

  const data = borrower[borrowerSeperator]
  if (!data) {
    if (validateOnly) {
      return false
    }
    return fields
  }

  const invisibleFields = getInvisibleFields(fieldOrigin as any)
  invisibleFields.forEach((key) => {
    if (fields[key]) fields[key].visible = false
  })

  let success = true

  Object.keys(fields).map((key) => {
    if (fields[key].visible === false) {
      delete fields[key]
      return
    }

    const value = borrower[borrowerSeperator]?.['customInformation']?.[fieldOrigin]?.[key] ?? ''

    const eff = getEffectiveFieldRequiredForBorrower(borrowerSeperator, fieldProps[key] || {})
    if (eff !== undefined) {
      fields[key].required = eff
    }

    // Linked fields are read-only mirrors — do not validate the local (often empty) copy.
    const linked = fieldProps[key]?.linkedField
    const isLinkedField = !!(linked?.fieldOrigin && linked?.fieldKey)
    const error = isLinkedField ? '' : InputValidate({ ...fields[key], value })
    fields[key].error = error
    if (error.length) success = false

    if (fieldProps[key]?.tooltip) {
      fields[key].tooltip = fieldProps[key].tooltip
    }

    let options = fields[key]?.options as any
    if (options && Array.isArray(options)) {
      try {
        options = options.filter((option: any) => {
          if (!option.visibleLogic) return true
          const isVisible = isVisibleFieldVisibleProps({ visibleLogic: option.visibleLogic })
          return isVisible
        }) as any
      } catch (e) {
        options = []
      }
      fields[key].options = options
    }
  })

  if (updateStore) {
    let application = cloneDeep(step.application)
    const key = borrowerMenuKey(borrowerSeperator, fieldOrigin)
    application[key] = success ? 1 : -1
    store.dispatch(setApplicationStep(application))
  }

  if (validateOnly) return success

  return fields
}
